import React from "react";
import { CheckCircle2, Clock, AlertTriangle } from "lucide-react";

const STYLES = {
  payee: {
    bg: "#DFF2E4",
    text: "#1E6534",
    border: "#B4E3C1",
    label: "Payée",
    Icon: CheckCircle2,
  },
  en_attente: {
    bg: "#FFF2D1",
    text: "#8C6100",
    border: "#FFE08A",
    label: "En attente",
    Icon: Clock,
  },
  en_retard: {
    bg: "#FCE8E8",
    text: "#B3261E",
    border: "#F8B4B4",
    label: "En retard",
    Icon: AlertTriangle,
  },
};

export const StatusBadge = ({ status, pulse = false }) => {
  const s = STYLES[status] || STYLES.en_attente;
  const Icon = s.Icon;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${
        pulse && status === "en_retard" ? "pulse-overdue" : ""
      }`}
      style={{
        backgroundColor: s.bg,
        color: s.text,
        borderColor: s.border,
      }}
    >
      <Icon size={12} strokeWidth={2} />
      {s.label}
    </span>
  );
};
